// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取OSS配置信息 GET /oss/config */
export async function ossConfigUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultAssumeRoleResponse>('/oss/config', {
    method: 'GET',
    ...(options || {}),
  });
}

/** oss上传临时凭证 GET /oss/token/${param0} */
export async function ossTokenIsVideoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ossTokenIsVideoUsingGETParams,
  options?: { [key: string]: any },
) {
  const { isVideo: param0, ...queryParams } = params;
  return request<API.BaseResultOssTokenResp>(`/oss/token/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}
